<template>
  <ul class="channel-list no-bullet" v-if="loading">
    <li class="pd-bottom-lg container"
      v-for="i in loadingItemCount"
    >
      <div class="channel-card round-sm">
        <div class="channel-info">
          <div class="avatar-line justify-row">
            <div class="avatar js-newpage"><a href=""
              @click.prevent=""
            ><img class="round-sm" :src="constants.phImg70x70" alt=""></a></div>
            <div class="main-item">
              <h2 class="name js-newpage"><a href="" class="ph-text"
                @click.prevent=""
              >■■■■■■■■■■■■■■■■■■■■■■■■■</a></h2>
              <v-ons-button class="subscribe js-button-toggle btn-outline ph-icon" modifier="small"
                disabled
                @click=""
              >
                <span class="icon-sm">
                  <icon-unsubscribe />
                </span>
                <span class="ph-text">■■■■■■■■■■</span>
              </v-ons-button>
            </div>
          </div>
          <p class="p ph-text">■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■ ■■■■■■■■■■■■■■■■ ■■■■■■■■ </p>
        </div>
        <aside>
          <ul class="list-with-divider tight no-bullet">
            <li class="justify-row"
              v-for="j in 2"
            >
              <div class="main-item">
                <h3 class="h3"><a class="js-newpage ph-text" href=""
                  @click.prevent=""
                >■■■■■■■■■■■■■■■</a></h3>
                <div class="quiet small">
                  <time datetime="" class="ph-text">■■■■■■■■</time>
                  <span class="duration ph-text">■■■■■■</span>
                </div>
              </div>
            </li>
          </ul>
        </aside>
      </div>
    </li>
  </ul>
  <ul class="channel-list no-bullet" v-else>
    <li class="pd-bottom-lg container"
      v-for="channel in channels"
      :key="channel.id"
    >
      <div class="channel-card round-sm">
        <div class="channel-info">
          <div class="avatar-line justify-row">
            <div class="avatar js-newpage"><a href=""
              @click.prevent="navigatorPush('Channel', { id: channel.id, title: channel.title })"
            ><img-with-placeholder class="round-sm" :src="constants.phImg70x70" :data-src="sizeImg(channel.image_base_url, 70, 70)" :alt="channel.image.alt_text" /></a></div>
            <div class="main-item">
              <h2 class="name js-newpage"><a href=""
                @click.prevent="navigatorPush('Channel', { id: channel.id, title: channel.title })"
              >{{ channel.title }}</a></h2>
              <div class="tools">
                <v-ons-button class="subscribe js-button-toggle btn-outline" modifier="small"
                  :disabled="channelLoading[channel.id]"
                  v-bind:class="{ switched: channel && channel.is_subscribed }"
                  @click="toggleSubscribe(channel)"
                >
                  <span class="icon-sm">
                    <icon-unsubscribe />
                  </span>
                  <span class="txt">{{ (channel && channel.is_subscribed) ? $t("channel.unsubscribe") : $t("channel.subscribe") }}</span>
                </v-ons-button>                
                <ons-button class="" modifier="small quiet"
                  v-if="channel.private"
                >
                  <span class="icon-sm">
                    <img src="@/assets/img/private.svg" alt="Private" width="30" height="30">
                  </span>
                </ons-button>
            </div>
            </div>
          </div>
          <p class="p">{{ channel.short_description | truncate(200) }}</p>
        </div>
        <aside>
          <ul class="list-with-divider tight no-bullet">
            <li class="justify-row"
              v-for="episode in channel.episodes.slice(0, 2)"
              :key="episode.id"
            >
              <div class="main-item">
                <h3 class="h3"><a class="js-newpage" href=""
                  @click.prevent="navigatorPush('Episode', { id: episode.id, title: episode.title })"
                >{{ episode.title }}</a></h3>
                <div class="quiet small">
                  <time :datetime="timestampToDate(episode.published_at)">{{ episode.published_at | timestampHumanizeFromNow | titleize }}, </time>
                  <span class="duration">{{ episode.duration | secondsToDuration }}</span>
                </div>
              </div>
              <div>
                <ons-button modifier="quiet" class="play js-button-toggle js-player-toggle"
                  v-bind:class="{ switched: episode.id === player.episodeId && player.playing, buffering: episode.id === player.episodeId && player.buffering }"
                  @click="playOrPause(episode, channel)"
                >
                  <icon-play />
                </ons-button>
                <ons-button modifier="quiet" class="download"
                  v-bind:class="{ pending: episode._download_status === 'PENDING', switched: episode._download_status === 'DOWNLOADING', complete: episode._download_status === 'DOWNLOADED' }"
                  @click="downloadOrCancel(episode, channel)"
                >
                  <icon-download :episode="episode" />
                </ons-button>
              </div>
            </li>
          </ul>
        </aside>
      </div>
    </li>
  </ul>
</template>

<script>
import PlayerHelper from '@/mixins/PlayerHelper';
import DownloadHelper from '@/mixins/DownloadHelper';

export default {
  props: ['channels', 'loading', 'loadingItemCount', 'onToggleSubscribeStart', 'onToggleSubscribeError', 'onToggleSubscribeEnd'],
  mixins: [PlayerHelper, DownloadHelper],

  data() {
    return {
      channelLoading: {},
    };
  },

  methods: {
    toggleSubscribe(channel) {
      if (!this.checkAndShowRequireLoginToast()) { return; }
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_sub"))) { return; }
      if (this.onToggleSubscribeStart) { setTimeout(() => { this.onToggleSubscribeStart(); }, 0); }
      this.channelLoading[channel.id] = true;
      channel.toggleSubscribe(this.currentUser.id)
        .then(() => {
          this.currentUser.updateSubscriptionsChanged(true);
        }).catch((error) => {
          if (this.onToggleSubscribeError) { setTimeout(() => { this.onToggleSubscribeError(error); }, 0); }
        }).finally(() => {
          this.channelLoading[channel.id] = false;
          if (this.onToggleSubscribeEnd) { setTimeout(() => { this.onToggleSubscribeEnd(); }, 0); }
          this.$forceUpdate();
          if (channel.is_subscribed) { this.askPushNotification(); }
        });
    },
  },
};
</script>
